exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-bf7a3276]{padding:20px 0}.detail[data-v-bf7a3276]{font-weight:700}.description[data-v-bf7a3276]:first-letter{text-transform:uppercase}.text[data-v-bf7a3276]{max-width:90%}", ""]);

// exports
